<template>
  <OverlayTemplate
    v-bind="$attrs"
    :config="templates"
    @add="addResult"
    @close="$emit('close', $event)"
  />
</template>

<script>
import OverlayTemplate from './OverlayTemplate'
import {
  SCORE_GVS_ADD_TEMPLATES,
  SCORE_GVS_ALL_TEMPLATES,
  SCORE_GVS_ECONOMIC_TEMPLATES,
  SCORE_GVS_EFFECT_TEMPLATES,
  SCORE_GVS_KI_TEMPLATES,
  SCORE_GVS_SAFETY_TEMPLATES,
} from './summaryTemplates'

export default {
  name: 'OverlayGvsQuestions',
  components: { OverlayTemplate },
  data: () => ({
    // templates: [
    //   { header: 'Качество КИ', templates: SCORE_KI_TEMPLATES },
    //   { header: 'Оценка безопасности', templates: SCORE_SAFETY_TEMPLATES },
    //   { header: 'КЭИ_АВБ', templates: SCORE_KEIAVB_TEMPLATES },
    //   { header: 'ГВС', templates: SCORE_GVS_TEMPLATES },
    //   { header: 'Прочие данные', templates: SCORE_OTHER_TEMPLATES },
    // ],
    templates: [
      { header: 'Клинические исследования', templates: SCORE_GVS_KI_TEMPLATES },
      { header: 'Эффективность', templates: SCORE_GVS_EFFECT_TEMPLATES },
      { header: 'Безопасность', templates: SCORE_GVS_SAFETY_TEMPLATES },
      {
        header: 'Экономические последствия',
        templates: SCORE_GVS_ECONOMIC_TEMPLATES,
      },
      { header: 'Дополнительные данные', templates: SCORE_GVS_ADD_TEMPLATES },
      { header: 'Общее', templates: SCORE_GVS_ALL_TEMPLATES },
    ],
  }),
  methods: {
    addResult(idx, template) {
      // const out = this.result.trimRight() + '\n' + template
      this.$emit('add', template)
    },
  },
}
</script>
